export const isSameDateTime = (left?: string | Date | null, right?: string | Date | null) => {
  if (!left && !right) return true;
  if (!left || !right) return false;
  return new Date(left).getTime() === new Date(right).getTime();
};
